var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading-container"},[_c('i',{staticClass:"fa fa-spinner fa-spin p-2"}),(_vm.message)?_c('span',[_vm._v(_vm._s(_vm.message))]):_vm._e()]):_c('div',[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }